/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RepresentantSelectorSearch
 */
export interface RepresentantSelectorSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof RepresentantSelectorSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RepresentantSelectorSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RepresentantSelectorSearch
     */
    numeroNational?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof RepresentantSelectorSearch
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof RepresentantSelectorSearch
     */
    nationalite?: StringListSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof RepresentantSelectorSearch
     */
    selectedRepresentantIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RepresentantSelectorSearch
     */
    excludedRepresentantIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepresentantSelectorSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RepresentantSelectorSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantSelectorSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantSelectorSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RepresentantSelectorSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantSelectorSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RepresentantSelectorSearch interface.
 */
export function instanceOfRepresentantSelectorSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RepresentantSelectorSearchFromJSON(json: any): RepresentantSelectorSearch {
    return RepresentantSelectorSearchFromJSONTyped(json, false);
}

export function RepresentantSelectorSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepresentantSelectorSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'numeroNational': !exists(json, 'numeroNational') ? undefined : TextSearchFromJSON(json['numeroNational']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'nationalite': !exists(json, 'nationalite') ? undefined : StringListSearchFromJSON(json['nationalite']),
        'selectedRepresentantIds': !exists(json, 'selectedRepresentantIds') ? undefined : json['selectedRepresentantIds'],
        'excludedRepresentantIds': !exists(json, 'excludedRepresentantIds') ? undefined : json['excludedRepresentantIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RepresentantSelectorSearchToJSON(value?: RepresentantSelectorSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'numeroNational': TextSearchToJSON(value.numeroNational),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'nationalite': StringListSearchToJSON(value.nationalite),
        'selectedRepresentantIds': value.selectedRepresentantIds,
        'excludedRepresentantIds': value.excludedRepresentantIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

